module.exports = __webpack_public_path__ + "static/media/instructor-4.04abe964.png";